import React, { useState } from 'react';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  COMMISSION_DEFAULT_PORTFOLIO,
  CB_100_FEE,
  CB_50_REFUND,
  COMMISSION_DEFAULT_AGIO,
} from '../utils/cashbackConstants';
import { InputSlider } from './InputSlider';
import { SimpleCalculatorChart } from './SimpleCalculatorChart';

const Container = styled('div')(({ theme }) => ({
  display: 'grid',
  maxWidth: '900px',
  gridTemplateColumns: '50% 50%',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '100%',
  },
  alignItems: 'center',
}));

const ChartContainer = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  paddingLeft: theme.spacing(5),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 0,
    marginTop: theme.spacing(2),
    height: '300px',
  },
}));

export const SimpleCalculator = () => {
  const [investedAmount, setInvestedAmount] = useState<number>(50000);
  const [plannedAmount, setPlannedAmount] = useState<number>(10000);

  const { t } = useTranslation();

  const estimateCashback = () => {
    const portfolioCommission = (investedAmount + plannedAmount) * COMMISSION_DEFAULT_PORTFOLIO;
    return portfolioCommission * CB_50_REFUND > portfolioCommission - CB_100_FEE
      ? Math.round(portfolioCommission * CB_50_REFUND)
      : Math.round(portfolioCommission - CB_100_FEE);
  };

  const estimateOneTimeCommission = () => {
    return Math.round(plannedAmount * COMMISSION_DEFAULT_AGIO);
  };

  const handleInvestedAmountChange = (amount: number) => {
    setInvestedAmount(amount);
  };

  const handlePlannedAmountChange = (amount: number) => {
    setPlannedAmount(amount);
  };

  return (
    <Container>
      <div>
        <InputSlider
          label={t('cashbackCalculator.simple.investedAmount')}
          defaultValue={investedAmount}
          maxValue={100000}
          onChange={handleInvestedAmountChange}
        />

        <InputSlider
          label={t('cashbackCalculator.simple.plannedInvestment')}
          defaultValue={plannedAmount}
          maxValue={20000}
          onChange={handlePlannedAmountChange}
        />
      </div>
      <ChartContainer>
        <SimpleCalculatorChart
          oneTimeCommission={estimateOneTimeCommission()}
          cashback={estimateCashback()}
        />
      </ChartContainer>
    </Container>
  );
};

export default SimpleCalculator;
